export const MAX_NUMBER_OF_SCENES = 64
export const MAX_NUMBER_OF_CONDITIONS = 8
export const MAX_NUMBER_OF_ACTIONS = 8
export const MAX_NUMBER_OF_BYTES_SCENE_NAME = 24
export const MAX_CONDITIONS_CHAIN = 7
export const MAX_ACTIONS_CHAIN = 7

export const MAX_NUMBER_OF_SCENES_BEFORE_500 = 30
export const MAX_NUMBER_OF_BYTES_SCENE_NAME_BEFORE_500 = 16
